// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 20px 20px 60px;
    display: flex;
    background-color: #013020;
    gap: 40px;
    min-height: calc(100vh - 100px); /* Adjust based on your header/footer */
}

/* Sidebar Styles */
.faq-page .sidebar {
    width: 350px;
    border: 1px solid #ddd;
    background-color: #265d38;
    padding: 20px;
    border-radius: 5px;
    margin-left: 50px;
    align-self: flex-start;
    position: sticky;
    top: 20px;
}

.faq-page .sidebar h2 {
    text-align: left;
    color: #ffcc00;
    margin-bottom: 20px;
    font-size: 1.5rem;
}

.faq-page .sidebar button {
    display: block;
    width: 100%;
    padding: 12px 15px;
    margin-bottom: 15px;
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: left;
    font-size: 1rem;
}

.faq-page .sidebar button:hover:not(.active) {
    background-color: #e0e0e0;
    transform: translateX(5px);
}

.faq-page .sidebar button.active {
    background-color: #265d38;
    color: #ffcc00;
    border: 1px solid #ffcc00;
}

/* Content Styles */
.faq-page .content {
    flex-grow: 1;
    padding: 20px;
}

.faq-content {
    background-color: #265d38;
    padding: 25px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.faq-content h2 {
    color: #ffcc00;
    margin-bottom: 20px;
    font-size: 1.8rem;
}

.faq-content p {
    color: #ffffff;
    margin-bottom: 15px;
    line-height: 1.6;
    font-size: 1.1rem;
}

.faq-content ul {
    list-style-type: none;
    padding-left: 20px;
    margin-bottom: 20px;
}

.faq-content ul li {
    color: #ffffff;
    margin-bottom: 10px;
    position: relative;
    padding-left: 20px;
    line-height: 1.5;
}

.faq-content ul li::before {
    content: "•";
    color: #ffcc00;
    position: absolute;
    left: 0;
    font-weight: bold;
}

/* Mobile Dropdown Styles */
.mobile-dropdown {
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    z-index: 1000;
}

.mobile-dropdown-header {
    background-color: #265d38;
    color: #ffcc00;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border: 2px solid #ffcc00;
}

.mobile-dropdown-header.active {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.dropdown-arrow {
    font-size: 0.8em;
    transition: transform 0.3s ease;
}

.dropdown-arrow.open {
    transform: rotate(180deg);
}

.mobile-dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #265d38;
    border: 2px solid #ffcc00;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.mobile-dropdown-item {
    padding: 15px;
    color: #ffcc00;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.mobile-dropdown-item:hover {
    background-color: #013020;
}

.mobile-dropdown-item.active {
    background-color: #013020;
}

/* Responsive Design */
@media (max-width: 768px) {
    .faq-page {
        flex-direction: column;
        padding: 15px;
    }

    .faq-page .sidebar {
        display: none;
    }

    .faq-page .content {
        padding: 10px 0;
    }

    .faq-content {
        padding: 15px;
    }

    .faq-content h2 {
        font-size: 1.5rem;
        margin-bottom: 15px;
    }

    .faq-content p {
        font-size: 1rem;
    }

    .faq-content ul {
        padding-left: 10px;
    }

    .faq-content ul li {
        font-size: 1rem;
        padding-left: 15px;
    }

    /* Mobile dropdown specific adjustments */
    .mobile-dropdown {
        margin-bottom: 15px;
    }

    .mobile-dropdown-header {
        padding: 12px;
    }

    .mobile-dropdown-item {
        padding: 12px;
    }
}

/* Additional breakpoint for very small devices */
@media (max-width: 380px) {
    .faq-page {
        padding: 10px;
    }

    .faq-content {
        padding: 12px;
    }

    .faq-content h2 {
        font-size: 1.3rem;
    }

    .faq-content p,
    .faq-content ul li {
        font-size: 0.95rem;
    }

    .mobile-dropdown-header,
    .mobile-dropdown-item {
        padding: 10px;
    }
}
.grade-table {
    width: 100%;
    margin: 20px 0;
    border-collapse: collapse;
    background-color: #013020;
    color: #ffffff;
}

.grade-table th,
.grade-table td {
    padding: 12px;
    text-align: left;
    border: 1px solid #ffcc00;
}

.grade-table th {
    background-color: #265d38;
    color: #ffcc00;
    font-weight: bold;
}

.grade-table tr:hover {
    background-color: #265d38;
}

.table-source {
    margin-top: 10px;
    font-size: 0.9rem;
    color: #ffffff;
    font-style: italic;
}

.source-link {
    color: #ffcc00;
    text-decoration: none;
}

.source-link:hover {
    text-decoration: underline;
}
/* Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInContent {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeOutContent {
    from {
        opacity: 1;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        transform: translateY(-10px);
    }
}

.faq-content.exiting {
    animation: fadeOutContent 0.3s ease-out;
}

.faq-content {
    animation: fadeInContent 0.4s ease-out;
    will-change: opacity, transform;
    backface-visibility: hidden;
    perspective: 1000px;
}`, "",{"version":3,"sources":["webpack://./src/FAQpage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,4BAA4B;IAC5B,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,+BAA+B,EAAE,uCAAuC;AAC5E;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA,yCAAyC;IACzC;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,iDAAiD;AACjD;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;IACjB;AACJ;AACA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;AACA,eAAe;AACf;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,4BAA4B;IAChC;AACJ;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;IAC/B,2BAA2B;IAC3B,mBAAmB;AACvB","sourcesContent":[".faq-page {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px 20px 20px 60px;\n    display: flex;\n    background-color: #013020;\n    gap: 40px;\n    min-height: calc(100vh - 100px); /* Adjust based on your header/footer */\n}\n\n/* Sidebar Styles */\n.faq-page .sidebar {\n    width: 350px;\n    border: 1px solid #ddd;\n    background-color: #265d38;\n    padding: 20px;\n    border-radius: 5px;\n    margin-left: 50px;\n    align-self: flex-start;\n    position: sticky;\n    top: 20px;\n}\n\n.faq-page .sidebar h2 {\n    text-align: left;\n    color: #ffcc00;\n    margin-bottom: 20px;\n    font-size: 1.5rem;\n}\n\n.faq-page .sidebar button {\n    display: block;\n    width: 100%;\n    padding: 12px 15px;\n    margin-bottom: 15px;\n    background-color: #ffffff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-align: left;\n    font-size: 1rem;\n}\n\n.faq-page .sidebar button:hover:not(.active) {\n    background-color: #e0e0e0;\n    transform: translateX(5px);\n}\n\n.faq-page .sidebar button.active {\n    background-color: #265d38;\n    color: #ffcc00;\n    border: 1px solid #ffcc00;\n}\n\n/* Content Styles */\n.faq-page .content {\n    flex-grow: 1;\n    padding: 20px;\n}\n\n.faq-content {\n    background-color: #265d38;\n    padding: 25px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.faq-content h2 {\n    color: #ffcc00;\n    margin-bottom: 20px;\n    font-size: 1.8rem;\n}\n\n.faq-content p {\n    color: #ffffff;\n    margin-bottom: 15px;\n    line-height: 1.6;\n    font-size: 1.1rem;\n}\n\n.faq-content ul {\n    list-style-type: none;\n    padding-left: 20px;\n    margin-bottom: 20px;\n}\n\n.faq-content ul li {\n    color: #ffffff;\n    margin-bottom: 10px;\n    position: relative;\n    padding-left: 20px;\n    line-height: 1.5;\n}\n\n.faq-content ul li::before {\n    content: \"•\";\n    color: #ffcc00;\n    position: absolute;\n    left: 0;\n    font-weight: bold;\n}\n\n/* Mobile Dropdown Styles */\n.mobile-dropdown {\n    width: 100%;\n    margin-bottom: 20px;\n    position: relative;\n    z-index: 1000;\n}\n\n.mobile-dropdown-header {\n    background-color: #265d38;\n    color: #ffcc00;\n    padding: 15px;\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    border: 2px solid #ffcc00;\n}\n\n.mobile-dropdown-header.active {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.dropdown-arrow {\n    font-size: 0.8em;\n    transition: transform 0.3s ease;\n}\n\n.dropdown-arrow.open {\n    transform: rotate(180deg);\n}\n\n.mobile-dropdown-content {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: #265d38;\n    border: 2px solid #ffcc00;\n    border-top: none;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\n.mobile-dropdown-item {\n    padding: 15px;\n    color: #ffcc00;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.mobile-dropdown-item:hover {\n    background-color: #013020;\n}\n\n.mobile-dropdown-item.active {\n    background-color: #013020;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .faq-page {\n        flex-direction: column;\n        padding: 15px;\n    }\n\n    .faq-page .sidebar {\n        display: none;\n    }\n\n    .faq-page .content {\n        padding: 10px 0;\n    }\n\n    .faq-content {\n        padding: 15px;\n    }\n\n    .faq-content h2 {\n        font-size: 1.5rem;\n        margin-bottom: 15px;\n    }\n\n    .faq-content p {\n        font-size: 1rem;\n    }\n\n    .faq-content ul {\n        padding-left: 10px;\n    }\n\n    .faq-content ul li {\n        font-size: 1rem;\n        padding-left: 15px;\n    }\n\n    /* Mobile dropdown specific adjustments */\n    .mobile-dropdown {\n        margin-bottom: 15px;\n    }\n\n    .mobile-dropdown-header {\n        padding: 12px;\n    }\n\n    .mobile-dropdown-item {\n        padding: 12px;\n    }\n}\n\n/* Additional breakpoint for very small devices */\n@media (max-width: 380px) {\n    .faq-page {\n        padding: 10px;\n    }\n\n    .faq-content {\n        padding: 12px;\n    }\n\n    .faq-content h2 {\n        font-size: 1.3rem;\n    }\n\n    .faq-content p,\n    .faq-content ul li {\n        font-size: 0.95rem;\n    }\n\n    .mobile-dropdown-header,\n    .mobile-dropdown-item {\n        padding: 10px;\n    }\n}\n.grade-table {\n    width: 100%;\n    margin: 20px 0;\n    border-collapse: collapse;\n    background-color: #013020;\n    color: #ffffff;\n}\n\n.grade-table th,\n.grade-table td {\n    padding: 12px;\n    text-align: left;\n    border: 1px solid #ffcc00;\n}\n\n.grade-table th {\n    background-color: #265d38;\n    color: #ffcc00;\n    font-weight: bold;\n}\n\n.grade-table tr:hover {\n    background-color: #265d38;\n}\n\n.table-source {\n    margin-top: 10px;\n    font-size: 0.9rem;\n    color: #ffffff;\n    font-style: italic;\n}\n\n.source-link {\n    color: #ffcc00;\n    text-decoration: none;\n}\n\n.source-link:hover {\n    text-decoration: underline;\n}\n/* Animations */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeInContent {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeOutContent {\n    from {\n        opacity: 1;\n        transform: translateY(0);\n    }\n    to {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n}\n\n.faq-content.exiting {\n    animation: fadeOutContent 0.3s ease-out;\n}\n\n.faq-content {\n    animation: fadeInContent 0.4s ease-out;\n    will-change: opacity, transform;\n    backface-visibility: hidden;\n    perspective: 1000px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
